import { ref } from "vue";
import { useMarketContent, useShopwareContext } from "#imports";

export function useRegisteredProducts() {
  const { azureUser } = useAzureUser();
  const { apiInstance } = useShopwareContext();
  const { marketSetupAdmin } = useMarketContent();
  const { retrieveRegistration, deleteRegistration } = useBritaMiddleware();

  const registeredProductsList = ref([]);

  const fetchRegisteredProducts = async () => {
    try {
      const mwRegisteredProductsResponse = ref();
      mwRegisteredProductsResponse.value = await retrieveRegistration({
        // @ts-ignore
        token: azureUser.value?.idToken,
        // @ts-ignore
        email: azureUser.value?.username,
      });

      if (mwRegisteredProductsResponse.value?.products.length > 0) {
        const productSet = [
          ...new Set(
            mwRegisteredProductsResponse.value.products.map((product) => product?.productId),
          ),
        ];

        const { data: registrationProductListingData, error } = await useAsyncData(
          `registeredProductData`,
          async () => {
            const response = await apiInstance.invoke.post(
              `/store-api/product-registration-listing/${marketSetupAdmin.value?.productRegistrationListingId}`,
              { ids: productSet },
            );

            return response.data;
          },
        );
        if (!error.value) {
          const swRegistrableProducts = registrationProductListingData.value?.elements
            ?.map((element) => element.extensions.registerableProducts)
            .flat();

          mwRegisteredProductsResponse.value?.products?.forEach((product) => {
            const matched = swRegistrableProducts?.find(
              (registrationProduct) => registrationProduct.id === product.productId,
            );

            if (matched) {
              registeredProductsList.value.push({
                ...matched,
                registrationId: product.registrationId,
                registrationDate: product.date.replace(/-/g, "."),
              });
            }
          });
        } else {
          console.error("Store Api registrable products fetch failed", error.value);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeRegisteredProduct = async (registrationId = "") => {
    try {
      await deleteRegistration({
        registrationId: registrationId,
        // @ts-ignore
        token: azureUser.value?.idToken,
        // @ts-ignore
        email: azureUser.value?.username,
      });
      registeredProductsList.value = registeredProductsList.value.filter(
        (product) => product.registrationId !== registrationId,
      );
    } catch (e) {
      console.error("### An error occurred:", e);
    }
  };

  return {
    registeredProductsList,
    removeRegisteredProduct,
    fetchRegisteredProducts,
  };
}
